import { uniq } from 'lodash'
import { regexFormatter } from 'utils'
/**
 * Set inputs attributes by ids
 *
 * @export
 * @param {*} {
 *     fieldsWithValues = {},
 *     fieldsByIdReference = {},
 * }
 */
export function setInputsProps({
  fields: fieldsWithProps = {},
  reference: fieldsByIdReference = {},
}) {
  Object.keys(fieldsWithProps).forEach(inputName => {
    let rules = fieldsByIdReference[inputName]?.rules ? fieldsByIdReference[inputName].rules : {}
    if (fieldsWithProps[inputName].rules) {
      rules = {
        ...rules,
        ...fieldsWithProps[inputName].rules,
      }
    }
    fieldsByIdReference = {
      ...fieldsByIdReference,
      [inputName]: {
        ...fieldsByIdReference[inputName],
        ...fieldsWithProps[inputName],
        rules,
      },
    }
  })
  return fieldsByIdReference
}

/**
 *
 * set inputs value for multiLanguage
 * @export
 * @param {*} {
 *   fieldsWithItems = {},
 *   fieldsByIdReference = {},
 * }
 * @returns
 */
export function setInputmultiLanguageValue({
  languageKey = ``,
  value: { current = {}, next = `` } = {},
}) {
  const nextvalue = {
    ...current,
    [languageKey.toLowerCase()]: next,
  }
  return nextvalue
}

/**
 *
 * set props to tabs sections
 * @export
 * @param {*} {
 *   fieldsWithItems = {},
 *   fieldsByIdReference = {},
 * }
 * @returns
 */
export function changePropsToTabsSections(
  fieldsById=null,
  {
    sectionsReference = [],
    tabs = {
      es: {},
    },
    root = {},
  },
  overRide = false,
  promotion_kind=null,
  
) {
  sectionsReference.forEach(({ type,title,id=null }, index) => {
    /*if (type === `tabs`) {
      let section = sectionsReference[index]
      section = {
        ...section,
        ...root,
      }
      if (overRide === `all`) {
        section.tabsContent = { ...tabs }
      } else {
        Object.keys(tabs).forEach(tabIdentifier => {
          section.tabsContent[tabIdentifier] = overRide
            ? {
                ...tabs[tabIdentifier],
              }
            : {
                ...section.tabsContent[tabIdentifier],
                ...tabs[tabIdentifier],
              }
        })
      }
      sectionsReference[index] = section
    }*/
    if (title===`Información para Mercado Internacional`) {
      if (promotion_kind==2 || promotion_kind==3) {
        
        //SAARGO, MOSTRAR LA FAMOSA SECCI{ON}
        let section = sectionsReference[index]
        section["hidden"]=false;
        sectionsReference[index] = section
        console.log(section);
      }else{
        let section = sectionsReference[index]
        section["hidden"]=true;
        sectionsReference[index] = section
      }
    }

    /* SAARGO, ESTO FUNCIONA PERO DEBE IR DESHABILITADO PARA EL PROVEEDOR
    if (id===`pttab` || id==='entab') {
      console.log(id);
      if (promotion_kind==2 || promotion_kind==3) {
        
        //SAARGO, MOSTRAR LA FAMOSA SECCI{ON}
        let section = sectionsReference[index]
        section["hidden"]=false;
        sectionsReference[index] = section
        console.log(section);
      }else{
        let section = sectionsReference[index]
        section["hidden"]=true;
        sectionsReference[index] = section
      }
    }
    */

    if (id===`rango_precios`) {
      console.log(id);
      if (promotion_kind==2 || promotion_kind==3) {
    
        //SAARGO, MOSTRAR LA FAMOSA SECCI{ON}
        let section = sectionsReference[index]
        console.log("campos son",fieldsById);
        fieldsById["international_price_range"]["hidden"]=false;
      }else{
        fieldsById["international_price_range"]["hidden"]=true;
      }
    }
    
  })
  return sectionsReference
}

/**
 * Get Forms values from fieldsbyid
 *
 * @export
 * @param {*} fieldsById
 * @returns
 */
export function getFormsValues(fieldsById) {
  const formValues = {}
  // get values by id and name
  Object.keys(fieldsById).forEach(id => {
    const { value, name = null, rules: { format = false } = {} } = fieldsById[id]
    if (value) {
      if (name) {
        if (Array.isArray(value) && value.length > 0) {
          formValues[name] = formValues[name] ? [...formValues[name], ...value] : value
        }
        if (name === `price`) {
          formValues[name] = formValues[name] ? { ...formValues[name], ...value } : value
        }
        if (!Array.isArray(value)) {
          formValues[id] = format ? regexFormatter(value, format) : value
        }
      } else if ((Array.isArray(value) && value.length > 0) || !Array.isArray(value)) {
        if (Array.isArray(value)) {
          formValues[name] = formValues[name] ? [...formValues[name], ...value] : value
        } else {
          formValues[id] = format ? regexFormatter(value, format) : value
        }
      }
    }
  })
  // filter values
  Object.keys(formValues).forEach(fieldId => {
    if (Array.isArray(formValues[fieldId])) {
      const unique = uniq(formValues[fieldId])
      formValues[fieldId] = unique
    }
  })
  return formValues
}

/**
 * Get Renderable Title from experience title json
 *
 * @export
 * @param {*} title
 * @returns
 */
export function getExperienceTitle(title) {
  if (title && Object.keys(title).length > 0) {
    return title.es ? title.es : title.en ? title.en : title[Object.keys(title)[0]]
  }
  return `Nueva Experiencia`
}

/**
 * generate Random number by limit
 *
 * @export
 * @param {number} [maxLimit=9999]
 * @returns
 */
export function randomNumber(maxLimit = 9999) {
  return Math.round(Math.random() * maxLimit)
}

/**
 * Generate Random keys for iteration
 *
 * @export
 * @param {string} [prefix=`random-key`]
 * @param {*} [params=[]]
 */
export function generateRandomKey(prefix = `random-key`, param = ``) {
  return `${prefix}-${randomNumber()}-${param}`
}

/**
 *
 *  Collapse all sections, and tabs inner secions, also, set as active ES tab
 * @export
 * @param {*} sections
 * @returns
 */
export function collapseAndActivateEsp(sections, expanded = false, disabled = false) {
  // eslint-disable-next-line
  return sections.map(({ type, ...section }) => {
    if (type === `tabs`) {
      try{ //SAARGO , TRY AGREGADO X SAARGO
          const {
            tabsContent: {
              es: { tabsSections },
            },
          } = section
          const inner = tabsSections.map(innerSection => ({
            ...innerSection,
            expanded,
            disabled,
          }))
          Object.keys(section.tabsContent).forEach(tabName => {
            if (tabName === `es`) {
              section.tabsContent[tabName].tabsSections = inner
            }
            section.tabsContent[tabName].disabled = disabled
          })
          return {
            ...section,
            type,
            active: `es`,
          }
      }catch(err){
        return {
          ...section,
          type,
          active: `es`,
        }
      }
      
    }
    if (type === `section`) {
      return {
        ...section,
        type,
        expanded,
        disabled,
      }
    }
  })
}

/**
 * Set languages in title and descriptions
 *
 * @export
 */
export function setLanguagesInputs({ languages, fields }) {
  let { title, short_description, long_description, languagesAvailable } = fields
  languagesAvailable.value = languages
  languagesAvailable.error = null
  const nextValues = {
    title: { es: title.value?.es },
    short_description: { es: short_description.value?.es },
    long_description: { es: long_description.value?.es },
  }
  // set input next langauages values by abrv
  languages.forEach(abrv => {
    nextValues.title[abrv] = title.value[abrv] ? title.value[abrv] : ``
    nextValues.short_description[abrv] = short_description.value[abrv]
      ? short_description.value[abrv]
      : ``
    nextValues.long_description[abrv] = long_description.value[abrv]
      ? long_description.value[abrv]
      : ``
  })
  title = {
    ...title,
    value: nextValues.title,
    error: null,
  }
  short_description = {
    ...short_description,
    value: nextValues.short_description,
    error: null,
  }
  long_description = {
    ...long_description,
    value: nextValues.long_description,
    error: null,
  }
  return { ...fields, title, short_description, long_description, languagesAvailable }
}

export function getMultilanguageFieldValue(field, language) {
  if (!field) {
    return null
  }
  return field[language] ? field[language] : field.en
}
